import { AxiosRequestConfig } from 'axios';
import { ajax, HttpResponse } from '../../../../common/ajax';
import { config } from '../../config';
import { InformationItem } from '../../models/information';

interface IInformationService {
  getInformation: (
    informationId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<InformationItem>>;
}

export const informationService: IInformationService = {
  getInformation(informationId, axiosConfig) {
    return ajax.get<InformationItem>(
      `${config.merchantsApiUrl}/information/${informationId}`,
      axiosConfig,
    );
  },
};
